/*
// @ts-nocheck
@ts-ignore
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import iconHeartSelected from "assets/icons/heart-selected.svg";
import iconStartUnselected from "assets/icons/heart-unselected.svg";
import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import { NotFoundWrapper } from "components/pages/dormitories-page";
import PaginationControl from "components/tools/pagination-control";
import { Control } from "components/ui-kit/control";
import {
    Breadcrumb,
    Button,
    Container,
    Form,
    Frame,
    Row,
    RowWrapper,
    TExtra
} from "components/ui-kit/styled-templates";

import { MEAL_PLAN_OPTIONS, resolveFileUrl } from "constants/config";
import districts from "constants/districts";

import ReviewsApi from "api/reviews-api";
import UniversityApi from "api/university-api";
import UserApi from "api/user-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EForms, EModals } from "types/enums";

import accessibiltyImage from "../../assets/images/accessibility.svg";
import Select from "react-select";
import HoverDatePicker from "components/tools/hover-date-picker";

const dormitoriesStub = new Array(54).fill({});

export const interferance = (path: string, value: any) => (i: any) => _.get(i, path)?.includes?.(value ?? ``);
export const arrayToOptions = (i: any) => ({ value: i, label: i });

const SearchResultsPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    let isRu = i18n.language === `ru`;

    useBodyBackground(`white`);

    const universities = useStorageListener(`universities`, {});
    const dormitories = useStorageListener(`dormitories`, {});
    const rooms = useStorageListener(`rooms`, {});
    const reviews = useStorageListener(`reviews`, []);

    const { data, clearForm, setValues } = useFormControl({ name: EForms.searchFilters });
    console.log("form: data = ", data);
    console.log("dorms = ", _(dormitories).values().value());
    console.log("dormitories = ", dormitories);

    // Валидация диапазона дат: дата начала не может быть позже даты окончания
    useEffect(() => {
        if (data.dateFrom && data.dateTo) {
            const fromTimestamp = +data.dateFrom;
            const toTimestamp = +data.dateTo;
            if (fromTimestamp > toTimestamp) {
                // Если дата начала позже даты окончания - меняем местами
                setValues({ ...data, dateFrom: data.dateTo, dateTo: data.dateFrom });
            }
        }
    }, [data.dateFrom, data.dateTo]);

    const selectedRooms = _(rooms).values().filter(interferance("details.type", data.type)).map(`dormitoryId`).uniq().value();

    const getEventRating = (dormitoryId) => {
        const dormitoryReviews = _(reviews)
            .filter((i) => i.published)
            .filter({ dormitoryId })
            .value();
        const dormitoryRating = _(dormitoryReviews).map(`rating`).sum() / (dormitoryReviews.length || 1);
        return dormitoryRating;
    };

    // let allowedDorms = dormitories.filter((x) => (x?.onModeration == false && x?.hideFromAll != true));
    let allowedDormitoriesMap = _(dormitories).values().filter((x) => (x?.onModeration == false && x?.hideFromAll != true)).keyBy("id").value();
    console.log("allowedDormitoriesMap = ", allowedDormitoriesMap);

    let filteredDormitories = _(allowedDormitoriesMap)
        .values()
        .filter({ onModeration: false })
        .map((i) => ({
            ...i,
            country: (_.get(universities, `${i.universityId}.details.country`) ?? _.get(i, "details.main-info.country")) || "РОССИЯ",
            district: _.get(universities, `${i.universityId}.details.district`) ?? _.get(i, "details.main-info.district"),
            rating: getEventRating(i.id),
            region: _.get(universities, `${i.universityId}.details.region`)
        }))

        .filter(interferance("details.main-info.city", data.city))
        .filter(interferance("universityId", data.university))
        .filter(interferance("details.main-info.mealPlan", data.mealPlan))
        .filter(interferance("region", data.region))
        .filter(interferance("district", data.district))
        .filter(interferance("country", data.country))
        // .filter((i) => i?.details?.documents?.length > 0)
        .filter((i) => selectedRooms.includes(i.id))
        .filter((i) => {
            // Filter by rules completness
            // TODO: Redo this using yup schema
            const requiredFields = [`requiredUniDocuments`, `requiredStudentsDocuments`, `committee.email`, `committee.phone`, `committee.name`];
            return requiredFields.map((path) => _.get(i, `details.rules.${path}`)).filter((i) => !i).length === 0;
        })
        .sortBy([`details.main-info.name`])
        .orderBy("rating", data.ratingDirection || "desc")
        .value();

    console.log("render: data = ", data);
    filteredDormitories = filteredDormitories.filter((x) => (x?.onModeration == false && x?.hideFromAll != true));
    if (data.accessibilityEnabled == true) {
        filteredDormitories = filteredDormitories.filter((x) => x?.accessibilityEnabled == true);
    }

    // Фильтрация по датам путешествия (пересечение диапазонов)
    if (data.dateFrom && data.dateTo && !isNaN(+data.dateFrom) && !isNaN(+data.dateTo)) {
        const userFrom = +moment(+data.dateFrom).startOf('day');
        const userTo = +moment(+data.dateTo).endOf('day');

        filteredDormitories = filteredDormitories.filter(dormitory => {
            // Получаем все комнаты этого общежития
            const dormitoryRooms = _.values(rooms).filter((r: any) => r.dormitoryId === dormitory.id);

            // Проверяем, есть ли хотя бы одна комната, доступная в указанные даты
            return dormitoryRooms.some((room: any) => {
                // Если комната всегда доступна - показываем
                if (room.details?.isAlwaysAvailable) return true;

                // Проверяем пересечение диапазонов дат
                const roomFrom = +room.details?.dateRange?.from;
                const roomTo = +room.details?.dateRange?.to;

                if (roomFrom && roomTo && !isNaN(roomFrom) && !isNaN(roomTo)) {
                    // Любое пересечение диапазонов: userFrom <= roomTo && userTo >= roomFrom
                    return userFrom <= roomTo && userTo >= roomFrom;
                }

                // Если нет данных о датах - считаем доступной
                return true;
            });
        });
    }

    const filterOptions = {
        district: _(allowedDormitoriesMap as any)
            .values()
            .map("details.district")
            .uniq()
            .filter(_.isString)
            .map((i) => ({
                value: i,
                label: _(districts as any)
                    .keyBy("id")
                    .get(`${i}.name`)
            }))
            // .map(arrayToOptions)
            .orderBy("label", "asc")
            .value(),
        city: _(filteredDormitories as any)
            .values()
            .map(`details.main-info.city`)
            .filter(_.isString)
            .uniq()
            .map(arrayToOptions)
            .orderBy("label", "asc")
            .value(),
        country: _(filteredDormitories as any)
            .values()
            .map(`details.main-info.country`)
            .filter(x => (x != "" && x != undefined))
            .concat("РОССИЯ")
            .concat("АБХАЗИЯ")
            .uniq()
            .map(arrayToOptions)
            .orderBy("label", "asc")
            .value(),
        university: _(filteredDormitories as any)
            .values()
            .map(`universityId`)
            .uniq()
            .map((i) => ({
                value: i,
                label: _.get(universities, `${i}.details.shortName`, _.get(universities, `${i}.details.name`, ""))
            }))
            .orderBy("label", "asc")
            .value(),
        mealPlan: _(filteredDormitories as any)
            .values()
            .map(`details.main-info.mealPlan`)
            .uniq()
            .map((i) => _.keyBy(MEAL_PLAN_OPTIONS, "value")[i])
            .orderBy("label", "asc")
            .value(),
        type: _(filteredDormitories as any)
            .values()
            .map(`rooms`)
            .map(_.values)
            .flatten()
            .map("details.type")
            .uniq()
            .map(arrayToOptions)
            .orderBy("label", "asc")
            .value(),
        region: _(filteredDormitories as any)
            .values()
            .map("universityId")
            .map((universityId) => _.get(universities, `${universityId}.details.region`))
            .uniq()
            .map(arrayToOptions)
            .sortBy([`label`])
            .value(),
        ratingDirection: ["asc", "desc"].map((i) => ({
            value: i,
            label: t(`searchResultsPage.ratingDirection.${i}`)
        }))
    };

    let isRussiaSelected = data.country == "РОССИЯ";

    let accessibilityOptions = [
        {
            label: isRu ? "Да" : "Yes",
            value: true
        }
        // {
        //     label: 'Нет',
        //     value: false
        // }
    ];

    console.log("-->> filterOptions = ", filterOptions);
    let filteredRegions = (filterOptions?.region || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf("ЕА") > -1) {
            s1 = `_${s1}`;
        }
        if (s2.indexOf("ЕА") > -1) {
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    });

    let filterDistricts = (filterOptions?.district || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf("ЕА") > -1) {
            s1 = `_${s1}`;
        }
        if (s2.indexOf("ЕА") > -1) {
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    }).filter(x => (x.value != undefined && x.value.indexOf("ЕА") == -1));


    const paginationResult = usePagination(filteredDormitories as any, { perPage: 4 });
    const { visibleItems } = paginationResult;

    const handlers = {
        openMapModal: () => {
            ModalsService.showModal(EModals.Map, filteredDormitories);
        }
    };

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        ReviewsApi.getAllReviews();
    }, []);

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    return (
        <Container extra={`align-items: flex-start;`}>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("uhftr6jxuw")}</Breadcrumb.Item>
                <Breadcrumb.Item to="/search">{t("ngm3xhhkxq")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper
                extra={`h1 { margin: 0; display: flex; flex-direction: row; justify-content: space-between; };`}>
                <h1>{t("c16i85mcm1l")}</h1>
                <Button

                    onClick={() => {
                        navigate("/international");
                    }}>
                    {isRu ? "Международные программы" : "International programs"}
                </Button>
            </RowWrapper>
            <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 32px; align-items: flex-start;`}>
                <FiltersWrapper name={EForms.searchFilters}>
                    <h2>{t("nbujwc9pcgj")}</h2>
                    {/* <Control.Select name="region" placeholder="Субъект" label="Субъект" options={[{ label: `123`, value: `123` }]} /> */}

                    {/*<Control.Select name="country" placeholder={isRu ? 'Страна' : 'Country'} label={isRu ? 'Страна' : 'Country'} options={filterOptions.country} />*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{isRu ? "Страна" : "Country"}</Label>
                        </div>
                        <Select
                            name="country"
                            placeholder={isRu ? "Страна" : "Country"}
                            options={filterOptions.country}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, country: val });
                            }}
                        />
                    </div>

                    {isRussiaSelected == false ? null :
                        <>

                            <div className={"mb-8"}>
                                <div>
                                    <Label>{t("jhsohjy7jf")}</Label>
                                </div>
                                <Select
                                    name="district"
                                    placeholder={t("fkb2qpacijd")}
                                    options={filterDistricts}
                                    isClearable={true}
                                    onChange={x => {
                                        let val = x?.value;
                                        setValues({ ...data, district: val });
                                    }}
                                />
                            </div>

                            <div className={"mb-8"}>
                                <div>
                                    <Label>{t("91parqfw3d")}</Label>
                                </div>
                                <Select
                                    name="region"
                                    placeholder={t("sd1hnuvfi3f")}
                                    options={filteredRegions}
                                    isClearable={true}
                                    onChange={x => {
                                        let val = x?.value;
                                        setValues({ ...data, region: val });
                                    }}
                                />
                            </div>

                            {/*<Control.Select*/}
                            {/*    name="district"*/}
                            {/*    placeholder={t("fkb2qpacijd")}*/}
                            {/*    label={t("jhsohjy7jf")}*/}
                            {/*    options={filterDistricts}*/}
                            {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                            {/*/>*/}

                        </>
                    }

                    {/*<Control.Select*/}
                    {/*    name="district"*/}
                    {/*    placeholder={'Россия'}*/}
                    {/*    label={'Страна'}*/}
                    {/*    options={filterDistricts}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}


                    {/*<Control.Select name="region" placeholder={t("sd1hnuvfi3f")} label={t("91parqfw3d")} options={filteredRegions} />*/}



                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("zg42ckqyrus")}</Label>
                        </div>
                        <Select
                            name="city"
                            placeholder={t("zg42ckqyrus")}
                            options={filterOptions.city}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, city: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="city"*/}
                    {/*    placeholder={t("zg42ckqyrus")}*/}
                    {/*    label={t("06u738umjv1i")}*/}
                    {/*    options={filterOptions.city}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("9g5exx0yvw5")}</Label>
                        </div>
                        <Select
                            name="university"
                            placeholder={t("xi1kx9ahhsd")}
                            options={filterOptions.university}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, university: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="university"*/}
                    {/*    placeholder={t("xi1kx9ahhsd")}*/}
                    {/*    label={t("9g5exx0yvw5")}*/}
                    {/*    options={filterOptions.university}*/}
                    {/*    menuProps={{ extra: `> * { max-width: 250px; }` }}*/}
                    {/*/>*/}
                    {/* <Control.Select
                            name="bedNumber"
                            placeholder="Количество мест"
                            label="Количество мест"
                            options={[{ label: `123`, value: `123` }]}
                        /> */}
                    {/*<Control.Select name="type" placeholder={t("01h0actislkd")} label={t("gf3tvp5zzim")}*/}
                    {/*                options={filterOptions.type} />*/}



                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("gf3tvp5zzim")}</Label>
                        </div>
                        <Select
                            name="type"
                            placeholder={t("01h0actislkd")}
                            options={filterOptions.type}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, type: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select name="mealPlan" placeholder={t("ufvp0iyg6r")} label={t("n38v9gx3gz")}*/}
                    {/*                options={filterOptions.mealPlan} />*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("n38v9gx3gz")}</Label>
                        </div>
                        <Select
                            name="mealPlan"
                            placeholder={t("ufvp0iyg6r")}
                            options={filterOptions.mealPlan}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, mealPlan: val });
                            }}
                        />
                    </div>

                    <div className={"mb-8"}>
                        <div>
                            <Label>{isRu ? "Доступно для лиц с ограниченными возможностями здоровья" : "Accessible for people with disabilities"}</Label>
                        </div>
                        <Select
                            name="accessibilityEnabled"
                            placeholder={isRu ? "Выберите" : "Select"}
                            options={accessibilityOptions}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, accessibilityEnabled: val });
                            }}
                        />
                    </div>


                    {/*<Control.Select*/}
                    {/*    name="accessibilityEnabled"*/}
                    {/*    placeholder={isRu ? "Доступно для лиц с ограниченными возможносятми" : "Accessible for people with disabilities"}*/}
                    {/*    label={isRu ? "Доступно для лиц с ограниченными возможносятми" : "Accessible for people with disabilities"}*/}
                    {/*    options={accessibilityOptions}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <div>
                            <Label>{t("ufvp0iyg6a")}</Label>
                        </div>
                        <Select
                            name="ratingDirection"
                            placeholder={t("ufvp0iyg6a")}
                            options={filterOptions.ratingDirection}
                            isClearable={true}
                            onChange={x => {
                                let val = x?.value;
                                setValues({ ...data, ratingDirection: val });
                            }}
                        />
                    </div>

                    {/*<Control.Select*/}
                    {/*    name="ratingDirection"*/}
                    {/*    placeholder={t("ufvp0iyg6a")}*/}
                    {/*    label={t("ufvp0iyg6a")}*/}
                    {/*    options={filterOptions.ratingDirection}*/}
                    {/*/>*/}

                    <div className={"mb-8"}>
                        <DateFilterHeader>
                            <Label>{isRu ? "Даты путешествия" : "Travel dates"}</Label>
                            {(data.dateFrom || data.dateTo) && (
                                <ClearDatesButton
                                    onClick={() => setValues({ ...data, dateFrom: undefined, dateTo: undefined })}
                                >
                                    {isRu ? "сбросить" : "clear"}
                                </ClearDatesButton>
                            )}
                        </DateFilterHeader>
                        <DateFilterRow>
                            <DateFilterField>
                                <HoverDatePicker
                                    value={data.dateFrom}
                                    placeholder={isRu ? "Дата заезда" : "Check-in"}
                                    withTime={false}
                                    saveOnSelect={true}
                                    onChange={(e: any) => setValues({ ...data, dateFrom: e.target.value })}
                                />
                            </DateFilterField>
                            <DateFilterField>
                                <HoverDatePicker
                                    value={data.dateTo}
                                    placeholder={isRu ? "Дата выезда" : "Check-out"}
                                    withTime={false}
                                    saveOnSelect={true}
                                    onChange={(e: any) => setValues({ ...data, dateTo: e.target.value })}
                                />
                            </DateFilterField>
                        </DateFilterRow>
                    </div>

                    <Row extra={`width: 100%; justify-content: center;`}>
                        <Button variant="outlined" extra="border: 0px;" onClick={clearForm}>
                            {t("uzdnpg1dnrq")}
                        </Button>
                    </Row>
                </FiltersWrapper>
                <Frame extra={`width: 100%; flex: 1; align-items: flex-start; gap: 15px 0;`}>
                    <RowWrapper extra={`justify-content: flex-start;`}>
                        <h2>
                            {t("wesauiyf7o9")} {paginationResult.totalCount}
                        </h2>
                        <MapIcon onClick={handlers.openMapModal} style={{ marginLeft: 15 }} />
                    </RowWrapper>
                    {visibleItems.map((item: any, index: number) => {
                        const goTo = (e) => {
                            if (e.target.className.includes("link-ignore")) {
                                return;
                            }
                            navigate(`/dormitory/${item?.id}`);
                        };
                        return (
                            <div key={index} onClick={goTo}>
                                <DormitorySearchPreview.Component
                                    dormitoryId={item?.id}
                                    {...item.details}
                                    rooms={_.values(rooms)?.filter?.((i) => i?.dormitoryId === item?.id)}
                                    university={_.get(universities, `${item?.universityId}.details`)}
                                    dateFrom={data.dateFrom}
                                    dateTo={data.dateTo}
                                />
                            </div>
                        );
                    })}
                    {!dormitoriesStub.length && <NotFoundWrapper>{t("hhn782ltkrm")}</NotFoundWrapper>}
                    <PaginationControl pagination={paginationResult} />
                </Frame>
            </RowWrapper>
        </Container>
    );
};

export const cutString = (str: string, maxLength: number) => (`${str}`.length > maxLength ? `${str}`.slice(0, maxLength) + `...` : `${str}`);

export const DormitorySearchPreview = {
    Component: ({ dormitoryId, ...dormitory }: any) => {
        const { t, i18n } = useTranslation();
        const isRu = i18n.language === 'ru';

        const { rooms, dateFrom, dateTo } = dormitory;
        const pricesArray = rooms.map((i) => +_.get(i, `details.price`));
        const price = { min: Math.min(...pricesArray), max: Math.max(...pricesArray) };
        const user = useStorageListener(`user`, {});
        const isStarred = _.get(user, "starredDormitories", []).includes(dormitoryId);

        // Подсчёт доступных комнат в выбранные даты
        const hasDateFilter = dateFrom && dateTo && !isNaN(+dateFrom) && !isNaN(+dateTo);
        let availableRoomsCount = 0;
        let availableRoomsInfo: string[] = [];

        if (hasDateFilter) {
            const userFrom = +moment(+dateFrom).startOf('day');
            const userTo = +moment(+dateTo).endOf('day');

            rooms.forEach((room: any) => {
                let isAvailable = false;

                if (room.details?.isAlwaysAvailable) {
                    isAvailable = true;
                } else {
                    const roomFrom = +room.details?.dateRange?.from;
                    const roomTo = +room.details?.dateRange?.to;
                    if (roomFrom && roomTo && !isNaN(roomFrom) && !isNaN(roomTo)) {
                        isAvailable = userFrom <= roomTo && userTo >= roomFrom;
                    } else {
                        isAvailable = true; // Нет данных о датах - считаем доступной
                    }
                }

                if (isAvailable) {
                    availableRoomsCount++;
                    const roomType = room.details?.type || (isRu ? 'Комната' : 'Room');
                    availableRoomsInfo.push(roomType);
                }
            });
        }

        const startDormitory = () => {
            UserApi.toggleDormitoryStar(dormitoryId);
        };
        return (
            <DormitorySearchPreview.Wrapper className="dorm_wrapper cursor-pointer">
                <DormitorySearchPreview.Photo src={resolveFileUrl(_.get(dormitory, `main-info.photos[0]`))} className={"dorm_photo"} />
                <DormitorySearchPreview.ContentWrapper className={"dorm_content_wrapper"}>
                    <div className="flex flex-row w-full justify-between items-center">
                        <h3>{_.get(dormitory, `main-info.name`)}</h3>
                        <img
                            alt=""
                            src={isStarred ? iconHeartSelected : iconStartUnselected}
                            className="link-ignore w-6 h-6 cursor-pointer"
                            onClick={startDormitory}
                        />
                    </div>
                    <span className="uni-name">{cutString(_.get(dormitory, `university.name`), 50)}</span>
                    <span className="region">{_.get(dormitory, `main-info.city`)}</span>
                    <DormitorySearchPreview.TableWrapper>
                        <Frame>
                            <span>{t("a7cnxlea33")}</span>
                            <strong>{rooms?.length}</strong>
                        </Frame>
                        <Frame>
                            <span>{t("5mu8pwn66qv")}</span>
                            <strong>{`от ${price.min}₽${price.max > price.min ? ` до ${price.max}₽` : ``}`}</strong>
                        </Frame>

                        <Frame>
                            <span>{t("dh6eg46nnfj")}</span>
                            <strong>{`от ${_.get(dormitory, `main-info.minDays`, `0`)} до ${_.get(
                                dormitory,
                                `main-info.maxDays`,
                                `1`
                            )} дней`}</strong>
                        </Frame>
                        {dormitory?.accessibilityEnabled != true ? null :
                            <Frame>
                                <img src={accessibiltyImage} style={{ height: "32px" }} />
                            </Frame>
                        }
                    </DormitorySearchPreview.TableWrapper>
                    {hasDateFilter && (
                        <AvailabilityInfo>
                            <span className="availability-label">
                                {isRu ? "Доступно в выбранные даты:" : "Available for selected dates:"}
                            </span>
                            <span className="availability-count">
                                {availableRoomsCount} {isRu ? (availableRoomsCount === 1 ? "вариант" : "вариантов") : (availableRoomsCount === 1 ? "option" : "options")}
                            </span>
                            {availableRoomsInfo.length > 0 && (
                                <span className="availability-types">
                                    ({_.uniq(availableRoomsInfo).join(", ")})
                                </span>
                            )}
                        </AvailabilityInfo>
                    )}
                </DormitorySearchPreview.ContentWrapper>
            </DormitorySearchPreview.Wrapper>
        );
    },
    Wrapper: styled(RowWrapper)`
      border: 1px solid ${({ theme }) => theme.halfblue};
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      align-items: flex-start;

      h3 {
        margin: 0 0 8px 0;
      }

      .uni-name {
        font-family: "Noto Sans", sans-serif;
        font-weight: 600;
        font-size: 18px;
        line-height: 27px;
        color: ${({ theme }) => theme.grey};
      }

      .region {
        font-weight: 400;
        font-size: 13px;
        line-height: 17px;
        color: ${({ theme }) => theme.blue};
      }
    `,
    Photo: styled(Frame)<{ src?: string; extra?: TExtra }>`
      width: 256px;
      height: 322px;
      background: ${({ theme }) => theme.lightblue};
      ${({ src }) => src && `background: url('${src}') no-repeat center center / cover;`}

      ${({ extra }) => extra}
    `,
    TableWrapper: styled(Row)`
      flex-wrap: wrap;
      gap: 16px 8px;
      margin-top: 16px;

      > * {
        align-items: flex-start;
        width: calc(50% - 8px);
        gap: 8px;
        font-size: 15px;
        line-height: 20px;
      }
    `,
    ContentWrapper: styled(Frame)`
      width: 100%;
      align-items: flex-start;
      justify-content: space-between;
      padding: 24px;
      box-sizing: border-box;
      height: 322px;
    `
};

const MapIcon = styled(Frame)`
  width: 56px;
  height: 56px;
  background: url("${require(`assets/icons/map-icon.svg`).default}") no-repeat center center / contain;
  cursor: pointer;

  &:after {
    content: "";
    width: 22px;
    height: 33px;
    background: url("${require(`assets/icons/map-pointer.svg`).default}") no-repeat center center / contain;
  }
`;

const FiltersWrapper = styled(Form)`
  width: 373px;
  background: ${({ theme }) => theme.lightblue};
  border-radius: 12px;
  padding: 40px 32px;
  box-sizing: border-box;

  h2 {
    margin: 0 0 15px 0;
  }

  span {
    background: white;
  }
`;

const Label = styled.div`
  color: rgb(33, 33, 33);
  margin-bottom: 8px;
  font-size: 14px;
`;

const DateFilterHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ClearDatesButton = styled.span`
  font-size: 12px;
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 8px;

  &:hover {
    color: #1565c0;
  }
`;

const DateFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const DateFilterField = styled.div`
  flex: 1;

  input {
    background: white;
    border-radius: 4px;
  }
`;

const AvailabilityInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #e8f5e9;
  border-radius: 6px;
  font-size: 13px;
  align-items: center;

  .availability-label {
    color: #2e7d32;
    font-weight: 500;
  }

  .availability-count {
    color: #1b5e20;
    font-weight: 600;
  }

  .availability-types {
    color: #388e3c;
    font-size: 12px;
  }
`;

export default SearchResultsPage;
